import { Alert } from 'react-bootstrap';
import useOpoProfile from '@nkr/store/opo/hooks/use-opo-profile';
import { SettingsPageWrapper } from '../styles';
import ProfileForm from './profile-form';

const ProfileSettings = () => {
    const { data, loading, error, save, isRoutingNumberValid, downloadDocument } = useOpoProfile();

    if (loading) {
        return null;
    }

    return (
        <SettingsPageWrapper>
            {error && (
                <Alert bsStyle='danger'>{error}</Alert>
            )}

            {data && (
                <ProfileForm
                    profile={data.profile}
                    canEdit={data.canEdit}
                    documents={data.documents}
                    regions={data.regions}
                    onSave={save}
                    isRoutingNumberValid={isRoutingNumberValid}
                    onDownloadDocument={downloadDocument}
                />
            )}
        </SettingsPageWrapper>
    );
}

export default ProfileSettings;
